import React, { Fragment } from 'react';

const Stepper: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  const childrenArray = React.Children.toArray(children);

  return (
    <div className="stepper tw-flex tw-flex-row tw-w-full tw-justify-between tw-items-center">
      {childrenArray.map((child: any, index: number) => (
        <Fragment key={index}>
          {child}
          {index !== childrenArray.length - 1 && (
            <span className="tw-block tw-mx-4 tw-w-[inherit] tw-h-[2px] tw-bg-blue-200" />
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default Stepper;
